const getRandomBanner = () => {
  const min = 1;
  const max = 4;
  const random = Math.floor(min + Math.random() * (max - min));

  return `https://static.schola.com/banners/Banner${random}-480px-01.jpg`;
};

export default getRandomBanner;
